import { LocaleTime } from '@mi-front/ui';
import moment from 'moment-timezone';
import React from 'react';
import { useTimezone } from '../../core/hooks/index';

interface Props extends React.ComponentProps<typeof LocaleTime> {
  tz?: string;
  showSeconds?: boolean;
}

export const LTime = (p: Props) => {
  const { value, tz: passedTz, showSeconds = false, ...rest } = p;
  const contextTz = useTimezone();
  const tz = passedTz || contextTz;

  return (
    <span title={moment(value).tz(tz).format('LLLL (Z)')}>
      <LocaleTime
        timeZone={tz}
        value={value}
        second={showSeconds ? '2-digit' : undefined}
        {...rest}
      />
    </span>
  );
};
